export default __webpack_public_path__ + "assets/f3d307da58bac26c045983930976a71a.svg";